export default "__VITE_ASSET__uapKOhKO__"